import { useRef, useCallback } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounce = <F extends (...args: any[]) => any>(
  callback: F,
  delay = 300
): ((...args: Parameters<F>) => void) => {
  const timeoutRef = useRef<number>();

  const debounce = (func: F): ((...args: Parameters<F>) => void) => {
    return (...args: Parameters<F>): void => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => func(...args), delay);
    };
  };

  return useCallback(debounce(callback), [callback]);
};

export default useDebounce;
